export default __webpack_public_path__ + "media/images/globe-dd3d31e7.svg";